import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { replayQueue } from "./offline-queue";
import { installMobileZoomGuard } from "./mobile-zoom";
import "./styles.css";

const installedPwa = window.matchMedia?.("(display-mode: standalone), (display-mode: fullscreen)").matches
  || Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
if (installedPwa) document.documentElement.classList.add("is-installed-pwa");

installMobileZoomGuard();
createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => void (async () => {
    let reloading = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });

    try {
      const registration = await navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" });
      let lastUpdateCheck = 0;
      const registerStandaloneClient = () => {
        if (!installedPwa) return;
        const worker = navigator.serviceWorker.controller ?? registration.active;
        worker?.postMessage({ type: "REGISTER_STANDALONE_CLIENT" });
      };
      const checkForUpdate = () => {
        const now = Date.now();
        if (now - lastUpdateCheck < 60_000) return;
        lastUpdateCheck = now;
        void registration.update().catch(() => undefined);
      };

      checkForUpdate();
      registerStandaloneClient();
      window.addEventListener("pageshow", () => {
        checkForUpdate();
        registerStandaloneClient();
      });
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          checkForUpdate();
          registerStandaloneClient();
        }
      });
    } catch {
      // A aplicação continua online mesmo se o navegador bloquear o modo instalável.
    }
  })());
}
window.addEventListener("online", () => void replayQueue());
